package link.erpango.quip.db

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Unit
import link.erpango.quip.db.composeApp.newInstance
import link.erpango.quip.db.composeApp.schema
import linkerpangoquipdb.AuthQueries
import linkerpangoquipdb.CommonFlagsQueries
import linkerpangoquipdb.CommonValuesQueries
import linkerpangoquipdb.GarageQueries
import linkerpangoquipdb.MaintenanceQueries
import linkerpangoquipdb.MaintenanceSparePartsQueries
import linkerpangoquipdb.SparePartQueries
import linkerpangoquipdb.UserQueries
import linkerpangoquipdb.Vehicle
import linkerpangoquipdb.VehicleCatalogQueries

public interface QuipDb : SuspendingTransacter {
  public val authQueries: AuthQueries

  public val commonFlagsQueries: CommonFlagsQueries

  public val commonValuesQueries: CommonValuesQueries

  public val garageQueries: GarageQueries

  public val maintenanceQueries: MaintenanceQueries

  public val maintenanceSparePartsQueries: MaintenanceSparePartsQueries

  public val sparePartQueries: SparePartQueries

  public val sparePartDocumentQueries: SparePartDocumentQueries

  public val userQueries: UserQueries

  public val vehicleCatalogQueries: VehicleCatalogQueries

  public val vehicleDocumentQueries: VehicleDocumentQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = QuipDb::class.schema

    public operator fun invoke(driver: SqlDriver, vehicleAdapter: Vehicle.Adapter): QuipDb = QuipDb::class.newInstance(driver, vehicleAdapter)
  }
}
